import utils from 'Utils';

const { pipeAll } = utils.fpHelpers;
const { isObject } = utils.obj;
const { escapeNewLines, escapeCSVQuotes } = utils.string;

const escapeFn = pipeAll([
  escapeNewLines,
  escapeCSVQuotes,
  (str) => `"${str}"`,
]);

/**
 * Process the cellbacks as needed
 * @param  {object} params cell parameters
 * @return {string}        cell value
 */
export default function processCellCallback(params) {
  const {
    value = '',
    node: { data },
  } = params;

  if (data.full) {
    if (data.active) {
      return escapeFn(`${data.name}, ${data.active.year}`);
    }
    return escapeFn(data.name);
  }

  if (isObject(value)) {
    return [
      escapeFn(value.formatted),
    ].join(',');
  }
  return escapeFn(value);
}



// WEBPACK FOOTER //
// ./app/services/download/processCellCallback.js